// Visibility rules of the per-period charts (PeriodicDetail.vue), extracted so the component and
// the Admin tab's list of hidden sections read the same source. The Admin tab needs to report on
// the Monthly and Weekly views while neither is mounted, so the rules cannot live in the component.

// One entry per chart, in render order. `dataKey` is the path shown in the Admin tab's
// "condition" column, relative to the object handed to PeriodicDetail (the plan results for the
// monthly view, `weekly_detail` for the weekly one).
export const PERIODIC_DETAIL_SECTIONS = [
  { key: 'budgetAllocation', dataKey: 'invest.media_spend' },
  { key: 'kpiByPeriod', dataKey: 'sales.time' },
  { key: 'salesDecomposition', dataKey: 'sales.sales_decomposition_by_period' },
  { key: 'mediaEffect', dataKey: 'sales.media_attributed_sales_decomposition_by_period' },
  { key: 'competitionEffect', dataKey: 'sales.competition_effect' },
  { key: 'economyAndOthersEffect', dataKey: 'sales.economy_and_others_effect' },
  { key: 'pricingEffect', dataKey: 'sales.pricing_effect' },
  { key: 'distributionEffect', dataKey: 'sales.distribution_effect' },
  { key: 'seasonalityAndOutliersEffect', dataKey: 'sales.seasonality_and_outliers_effect' }
]

// The sales object the charts read: the selected output, or the root when the KPI is the Total.
// Returns {} rather than undefined for a missing output so callers never dereference null.
export function resolvePeriodicSales (data, currentOutput) {
  if (!data || !data.sales) return {}
  if (currentOutput && currentOutput !== 'Total') {
    const outputs = data.sales.outputs
    return (outputs && outputs[currentOutput]) ? outputs[currentOutput] : {}
  }
  return data.sales
}

// { chartKey: boolean } for every entry of PERIODIC_DETAIL_SECTIONS.
export function periodicDetailVisibility (data, currentOutput) {
  const sales = resolvePeriodicSales(data, currentOutput)
  const invest = (data && data.invest) ? data.invest : {}
  return {
    budgetAllocation: !!invest.media_spend,
    kpiByPeriod: !!sales.time,
    salesDecomposition: !!sales.sales_decomposition_by_period,
    mediaEffect: !!sales.media_attributed_sales_decomposition_by_period,
    competitionEffect: !!sales.competition_effect,
    economyAndOthersEffect: !!sales.economy_and_others_effect,
    pricingEffect: !!sales.pricing_effect,
    distributionEffect: !!sales.distribution_effect,
    seasonalityAndOutliersEffect: !!sales.seasonality_and_outliers_effect
  }
}
